import { Box, Chip, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

type GenericAppliedFilter = Record<string, string | string[] | undefined>;

export interface ActiveFilterSectionProps {
  appliedFilter: GenericAppliedFilter;
  clearAllFilters: (apply: boolean) => void;
  clearFilter: (filterKey: string) => void;
  hideDateRange: boolean;
}

const ActiveFilterSection: React.FC<ActiveFilterSectionProps> = ({
  appliedFilter,
  clearAllFilters,
  clearFilter,
  hideDateRange,
}) => {
  const filterKeys = Object.keys(appliedFilter).filter((key) => {
    const filterValue = appliedFilter[key as keyof typeof appliedFilter];

    const isDateRangeFilter =
      key === "Date_Range" && hideDateRange && filterValue !== "-";

    return (
      (isDateRangeFilter || key !== "Date_Range") &&
      filterValue !== undefined &&
      (Array.isArray(filterValue) ? filterValue.length > 0 : !!filterValue)
    );
  });

  if (filterKeys.length === 0) {
    return null;
  }

  const getFilterLabel = (key: string): string => {
    if (key === "Account") {
      return "Customer Group";
    }
    if (key === "Account_Manager") {
      return "Customer Group Manager";
    }
    return key.replace("_", " ");
  };

  const getFilterValue = (key: string): string => {
    const filterValue = appliedFilter[key];
    return Array.isArray(filterValue)
      ? filterValue.join(", ")
      : String(filterValue);
  };

  return (
    <Box display="flex" alignItems="center" rowGap={0.5} flexWrap="wrap">
      <Typography
        color="rgba(58, 53, 65, 0.7)"
        sx={{ fontSize: "12px", fontWeight: "400" }}
      >
        Active Filters:
      </Typography>
      <Box
        display="flex"
        flexWrap="wrap"
        gap={1}
        flexGrow={1}
        alignItems={"center"}
      >
        {filterKeys.map((key) => (
          <Chip
            variant="outlined"
            key={key}
            label={`${getFilterLabel(key)}: ${getFilterValue(key)}`}
            onDelete={() => clearFilter(key)}
            sx={{
              maxWidth: "20vw",
              overflow: "hidden",
              border: "none",
            }}
            deleteIcon={
              <Box
                sx={{
                  backgroundColor: "#FF4C51",
                  borderRadius: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: "12px",
                  height: "12px",
                  margin: 0,
                }}
              >
                <CloseIcon
                  sx={{
                    color: "white",
                    width: "10px",
                    height: "10px",
                  }}
                />
              </Box>
            }
          />
        ))}
        <Typography
          variant="body2"
          color="#FF4C51"
          onClick={() => clearAllFilters(true)}
          sx={{
            cursor: "pointer",
            whiteSpace: "nowrap",
            alignItems: "center",
            fontSize: "12px",
            fontWeight: "400",
          }}
        >
          Clear All
        </Typography>
      </Box>
    </Box>
  );
};

export default ActiveFilterSection;
